var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcCrop = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-102.2%",
    y: "-78.2%",
    width: "304.4%",
    height: "304.4%",
    filterUnits: "objectBoundingBox",
    id: "7ol0zz841a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.32 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.7 1.683c.22 0 .4.18.4.4v12.06c0 .432.349.781.781.781h12.036a.4.4 0 1 1 0 .8H5.88a1.58 1.58 0 0 1-1.582-1.58V2.083c0-.222.18-.4.4-.4zm9.659 2.385A1.58 1.58 0 0 1 15.94 5.65v8.1a.4.4 0 1 1-.8 0v-8.1a.78.78 0 0 0-.782-.78H6.218a.4.4 0 1 1 0-.8h8.14zm1.262 12.329c.265 0 .48.179.48.4v1.12c0 .22-.215.4-.48.4s-.48-.18-.48-.4v-1.12c0-.221.215-.4.48-.4zM3.252 4.068c.221 0 .4.215.4.48s-.179.48-.4.48H2.083c-.22 0-.4-.215-.4-.48s.18-.48.4-.48h1.17z",
    id: "g7xppxlcfb"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#7ol0zz841a)",
    xlinkHref: "#g7xppxlcfb"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#g7xppxlcfb"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcCrop);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_crop.cb50e9e503dcb48707e6395d1c5b6f7b.svg";